import { Controller } from "@hotwired/stimulus"

// Live preview of the e-mail; the account box switches the preview only (the server reads the box
// itself, see GodsController#remove_account?).
export default class extends Controller {
  static targets = ["reason", "comment", "reasonText", "commentText", "account", "contentOnly", "accountOnly"]
  static values = { reasons: Object }

  connect() {
    this.update()
  }

  update() {
    const reason = this.reasonsValue[this.reasonTarget.value] || ""
    this.reasonTextTargets.forEach((element) => { element.textContent = reason })
    const comment = this.commentTarget.value.trim()
    this.commentTextTargets.forEach((element) => {
      element.textContent = comment
      element.hidden = comment === ""
    })

    if (!this.hasAccountTarget) return

    const account = this.accountTarget.checked
    this.contentOnlyTargets.forEach((element) => { element.hidden = account })
    this.accountOnlyTargets.forEach((element) => { element.hidden = !account })
  }
}
